import { ScreenBase } from "@frui.ts/screens";
import { action, observable } from "mobx";
import type ChargeResponse from "entities/chargeResponse";
import { Modules } from "config";
import type LocalizationService from "services/localizationService";

export default class ChargeConfirmationDialogViewModel extends ScreenBase {
  @observable isOpened = false;
  private onResult: (value: { confirmed: boolean; forceSingleChargeReceipt: boolean }) => void;

  readonly title: string;
  readonly message: string;
  readonly emailAddressChanged: boolean;
  readonly isBulkChargeOrder: boolean;

  @observable sendConfirmationForSingleChargeOnly = true;

  constructor(protected charge: ChargeResponse, public localizationService: LocalizationService) {
    super();

    this.title = charge.isBulkChargeOrder ? this.translate("bulkChargeOrderName") : this.translate("singleChargeOrderName");
    this.message = this.translate("confirmation").replace("%email%", charge.emailAddress ?? "");

    this.emailAddressChanged = charge.wasEmailChanged;
    this.isBulkChargeOrder = charge.isBulkChargeOrder;
  }

  get canBeNavigationActiveScreen() {
    return false;
  }

  @action.bound
  public showConfirmation() {
    this.isOpened = true;
    return new Promise<{ confirmed: boolean; forceSingleChargeReceipt: boolean }>(resolve => {
      this.onResult = resolve;
    });
  }

  @action.bound
  confirm() {
    this.isOpened = false;
    this.onResult({ confirmed: true, forceSingleChargeReceipt: this.sendConfirmationForSingleChargeOnly });
  }

  @action.bound
  cancel() {
    this.isOpened = false;
    this.onResult({ confirmed: false, forceSingleChargeReceipt: this.sendConfirmationForSingleChargeOnly });
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.callCenter, `sendPaymentConfirmation.${code}`, size);
  }
}
